<script>
const items = [
  {
    color: '#F8a71f',
    image: '/slider_1.png',
    text: 'LA BLONDE',
    url: '/boutique/la-blonde'
  },
  {
    color: '#2596be',
    image: '/slider_2.png',
    text: 'LA BRUNE',
    url: '/boutique/la-brune'
  }
]
export default {
  name: 'SliderHome',
  setup() {
    const handleMouseMove = (event) => {
      const element = document.getElementById('followMouseElement');
      const rect = element.getBoundingClientRect();
      const mouseX = event.clientX - rect.left;
      const mouseY = event.clientY - rect.top;

      const rotateX = ((mouseY / rect.height) - 0.5) * -15;
      const rotateY = ((mouseX / rect.width) - 0.5) * 15;

      element.style.transform = `rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;
    };

    const resetTransform = () => {
      const element = document.getElementById('followMouseElement');
      element.style.transform = 'rotateX(0deg) rotateY(0deg)';
    };

    return {
      resetTransform,
      handleMouseMove,
    };
  },
  data() {
    return {
      items,
      currentItems: 0,
      isAnimating: false,
      animationDirection: '',
      image: '',
      color: '',
      text: ''
    };
  },
  mounted () {
    this.image = this.items[this.currentItems].image
    this.color = this.items[this.currentItems].color
    this.text = this.items[this.currentItems].text
  },
  methods: {
    next(nbItem) {
      if (this.isAnimating) return;

      const direction = nbItem > this.currentItems ? 'prev' : 'prev';
      this.animationDirection = direction;
      this.isAnimating = true;

      if (nbItem < 0) {
        this.currentItems = this.items.length - 1;
      } else if (nbItem > this.items.length - 1) {
        this.currentItems = 0;
      } else {
        this.currentItems = nbItem;
      }
      this.image = this.items[this.currentItems].image
      this.color = this.items[this.currentItems].color
      const element = document.getElementById('followMouseElement');
      element.style.transform = 'rotateX(0deg) rotateY(0deg)';

      setTimeout(() => {
        this.text = this.items[this.currentItems].text
        this.animationDirection = '';
        this.isAnimating = false;
      }, 500);
    },
  },
};
</script>

<template>
  <div class="min-h-screen">
    <div class="home-beers-wrapper-inner">
      <div
          class="home-beers-polygon hbp-color"
          :style="{ 'background-color': color }"
      ></div>
      <div
          class="min-h-screen flex items-center justify-center"
          @mousemove="handleMouseMove"
          @mouseleave="resetTransform"
          style="perspective: 1000px;"
      >
        <div
            class="relative w-full mx-auto flex items-center"
            style="perspective: 1000px; padding-top: 200px; padding-bottom: 50px"
        >
          <div
              class="element justify-center w-2/3 items-center mx-auto"
              id="followMouseElement"
          >
            <img
                :src="image"
                alt="Bouteille Delirium Tremens"
                class="w-2/3 -rotate-12 transition-transform"
                :class="{
                'slide-out-back': isAnimating && animationDirection === 'next',
                'slide-in-left': isAnimating && animationDirection === 'prev',
              }"
            />
            <div
                class="flex flex-col w-full items-start"
                :class="{
                'slide-in-right': isAnimating && animationDirection === 'next',
                'slide-out-back': isAnimating && animationDirection === 'prev',
              }"
            >
              <h1 class="text-size font-extrabold text-white">
                <span class="uppercase font-sigmar tracking-wider">déglingo</span><br />
                <span class="uppercase ml-10 font-sigmar tracking-wider">{{ text }}</span>
              </h1>
              <router-link
                  :to="items[currentItems].url"
                  class="w-full lg:w-1/2 mt-6 px-6 py-3 border-2 border-white bg-transparent text-white font-semibold rounded-full flex items-center hover:text-primary-700 hover:shadow-primary-800 hover:bg-white hover:shadow-md transition"
              >
                Découvrez cette bière
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-5 w-5 ml-2"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                >
                  <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M17 8l4 4m0 0l-4 4m4-4H3"
                  />
                </svg>
              </router-link>
            </div>
          </div>
          <div
              class="absolute top-1/2 left-5 transform -translate-y-1/2"
          >
            <button
                @click="next(currentItems - 1)"
                class="w-12 h-12 rounded-full border-2 border-white text-white opacity-50 hover:opacity-80 flex items-center justify-center shadow-lg hover:shadow-xl transition"
            >
              <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
              >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M15 19l-7-7 7-7"
                />
              </svg>
            </button>
          </div>
          <div
              class="absolute top-1/2 right-5 transform -translate-y-1/2"
          >
            <button
                @click="next(currentItems + 1)"
                class="w-12 h-12 rounded-full border-2 border-white text-white flex opacity-50 hover:opacity-80 items-center justify-center shadow-lg hover:shadow-xl transition"
            >
              <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
              >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M9 5l7 7-7 7"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.home-beers-wrapper-inner {
  @apply relative w-full h-full transition-all;
}

.home-beers-polygon {
  @apply absolute w-full h-full bg-cover bg-center;
}


.hbp-delirium-tremens {
  @apply bg-primary-700;
}

@screen sm {
  .home-beers-polygon {
    clip-path: polygon(0 100%, 0 80px, 100% 0, 100% 100%);
  }
}

@screen md {
  .home-beers-polygon {
    clip-path: polygon(0 100%, 0 100px, 100% 0, 100% 100%);
  }
}

.home-beers-polygon {
  clip-path: polygon(0 100%, 0 150px, 100% 0, 100% 100%);
}


@keyframes slideOutBack {
  0% {
    opacity: 1;
    transform: translateZ(0) scale(1);
  }
  100% {
    opacity: 0;
    transform: translateZ(-200px) scale(0.8);
  }
}

@keyframes slideInLeft {
  0% {
    opacity: 0;
    transform: translateX(-100%);

  }
  100% {
    opacity: 1;
    transform: translateX(0);
    rotate: -12deg;
  }
}

@keyframes slideInRight {
  0% {
    opacity: 0;
    transform: translateX(100%);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

.slide-out-back {
  animation: slideOutBack 0.5s forwards;
}

.slide-in-left {
  animation: slideInLeft 0.5s forwards;
}

.slide-in-right {
  animation: slideInRight 0.5s forwards;
}


.element {
  display: flex;
}

.text-size {
  @apply text-7xl
}

@media (max-width: 1024px) {
  .element {
    flex-wrap: wrap;
  }
  .text-size {
    @apply text-3xl
  }
}
</style>